<template>
<li class="chat-display">
    <div class="box right" v-if="user.id === messageData.from">
        <div class="msg-content user-msg">
            <div class="dialog-arrow-user"></div>  
            <div class="timestamp left">{{getTimeStamp}}</div>         
            <div v-on:click="openCard" class="sender-name user">{{user.firstName}}</div>
            <div class="msg-text black">{{messageData.message}}</div>
        </div>
    </div>
    <div class="box" v-else>
        <img v-on:click="openCard" v-bind:src="pictureUrl" class="picture-icon">
        <div class="msg-content contact-msg">
            <div class="timestamp right">{{getTimeStamp}}</div>  
            <div v-if="person" v-on:click="openCard" class="sender-name black">{{person.firstName}}</div>
            <div class="msg-text">{{messageData.message}}</div>
            <div class="dialog-arrow"></div>    
        </div>
    </div>
</li>
</template>

<script>

// TODO: add time stamp
import {LeadBus} from '../../router/index';
import TimeUtils from '../../javascript-classes/utils/time';

// Constants
const ANONYMOUS_IMG = '/static/img/anonymous.svg';

export default {
    props: {
        messageData: {},
        person: {},
        user: {}
    },

    computed: {
        userPicture() {
            return this.user && this.user.pictureUrl && this.user.pictureUrl !== '' ? this.user.pictureUrl : ANONYMOUS_IMG;
        },

        pictureUrl() {
            return this.person && this.person.pictureUrl && this.person.pictureUrl !== '' ? this.person.pictureUrl : ANONYMOUS_IMG;
        },

        getTimeStamp() {
            return TimeUtils.formatFromNow(this.messageData.timestamp, (key) => { return this.$t('str.' + key); });
        }
    },

    methods: {
        openCard() {
            this.$emit('openPersonCard', this.person); 
            LeadBus.$emit('recordLead', {
                type: 'attendee-profile-card',
                data: {
                    profileCardOf: this.person.id
                }
            });
        }
    }
};

</script>

<style lang="scss">

.user-msg {
    background: #fff;
    float: right;
}

.user {
    color: #d4451d;
    text-align: right;
}

.black {
    color: #000;
}

.contact-msg {
    background: #d4451d;
}

.chat-display {
    .right {
        float: right;
    }

    .left {
        float: left;
    }

    .box {
        list-style-type: none;
        margin-bottom: 4px;
        width: 100%;

        .picture-icon {
            width: 50px;
            border-style: none;
            border-radius: 50%;
            cursor: pointer;
            vertical-align: top;
        }

        .msg-content {
            margin-left: 10px;
            margin-right: 20px;
            max-width: 60%;
            min-width: 100px;
            padding-bottom: 6px;
            font-family: "Poppins", sans-serif;
            padding: 5px 10px;
            border-radius: 0px;
            position: relative;
            display: inline-block;
            min-height: 40px;
            border-radius: 15px 15px 15px 15px;

            .sender-name {
                text-decoration: none;
                font-size: 13px;
                font-weight: 600;
                cursor: pointer;
            }

            .timestamp {
                font-size: 0.75rem;
                color: grey;
            }

            .timestamp.right {
                color: #d0d0d0;
            }

            .msg-text {
                font-family: 'Poppins', sans-serif;
                font-size: 1em;
                line-height: 1.2em;
                overflow-wrap: break-word;
            }
        }
    }
}

.dialog-arrow {
    right: calc(100% - 1px);
    border: solid transparent;
    border-right-color: #d4451d;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: 10px;
    top: 15px;
}

.dialog-arrow-user {
    left: calc(100% - 1px);
    border: solid transparent;
    border-right-color: #fff;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: 10px;
    top: 15px;
    transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// ChatBox.vue?641cd10b